<template>
  <div style="width: 98%; margin: 0 auto">
    <el-tabs v-model="activeName" @tab-click="handleClickTab">
      <el-tab-pane label="会议详情" name="first">
        <div class="infoBox">
          <el-row>
            <el-col :md="24" :lg="24" :xl="11">
              <el-card class="box-card" style="margin-top: 10px">
                <div slot="header" class="clearfix">
                  <span class="them">( 编号：{{ meeting.id }} )</span>
                  <span class="them">{{ meeting.meeting_subject }}</span
                  >&nbsp;&nbsp;&nbsp;
                  <span
                    >会议预计时间：{{ meeting.estimate_start_time }} ~
                    {{ meeting.estimate_end_time }}</span
                  >&nbsp;&nbsp; <span>最后更新：{{ meeting.update_time }}</span
                  >&nbsp;&nbsp;
                </div>
                <el-row>
                  <el-col :span="4" style="min-width: 100px">
                    <img
                      :src="meeting.room.avatar"
                      style="width: 100px; height: 100px"
                      alt
                    />
                  </el-col>
                  <el-col :span="20">
                    <div>
                      <span>会议室：{{ meeting.room.name }}</span
                      >&nbsp;&nbsp;&nbsp;&nbsp;
                      <span
                        >会议地点：{{ meeting.address.address }} -
                        {{ meeting.room.area }}</span
                      >&nbsp;&nbsp;&nbsp;&nbsp;
                      <span>会议类型：{{ meeting.meeting_type }}</span>
                    </div>
                    <p>
                      <!-- <span>申请人: {{ meeting.applicant.name }}</span>&nbsp;&nbsp; -->
                      <span>参会人数：{{ meeting.number }}人</span>&nbsp;&nbsp;
                      <span>
                        <tags
                          :meeting_status="meeting.meeting_status"
                        ></tags> </span
                      >&nbsp;&nbsp;
                      <span
                        >会议实际时间：{{ meeting.start_time }} ~
                        {{ meeting.end_time }}</span
                      >
                      &nbsp;&nbsp;
                    </p>
                    <p>所属部门：{{ meeting.secretary_department_name }}</p>
                    <p>
                      <span>召集人：{{ meeting.convenor.name }}</span
                      >&nbsp;&nbsp;&nbsp;&nbsp;
                      <span>会议秘书：{{ meeting.secretary.name }}</span
                      >&nbsp;&nbsp;&nbsp;&nbsp;
                      <!-- <span>联系人: {{ meeting.contact.name }}</span>&nbsp;&nbsp; -->
                      <span>主持人：{{ meeting.host.name }}</span>
                    </p>
                    <span>
                      参会者：
                      <span
                        v-for="(items, index) in meeting.attendees"
                        :key="index"
                        >{{ items.name }} ,</span
                      >
                    </span>
                    <p>
                      保密类型：{{
                        meeting.secrecy_type === 1
                          ? "一级会议（保密）"
                          : "普通会议（非保密）"
                      }}
                    </p>
                    <el-button
                      v-if="
                        (meeting.secretary.workcode ==
                          $store.getters.username ||
                          meeting.host.workcode == $store.getters.username ||
                          meeting.convenor.workcode ==
                            $store.getters.username) &&
                        meeting.meeting_status == 1
                      "
                      type="text"
                      size="small"
                      @click="addAttendeesVisible = true"
                      >添加参会人</el-button
                    >
                    <!-- <p>备注：{{ meeting.describe }}</p> -->
                    <p>
                      <el-tag
                        v-for="(items, index) in meeting.equipments"
                        :key="index"
                        type="info"
                        size="small"
                        style="margin-left: 5px"
                        >{{ items.equipment_name }}</el-tag
                      >
                    </p>
                    <el-button
                      v-if="
                        meeting.meeting_status == 0 &&
                        (meeting.secretary.workcode ==
                          $store.getters.username ||
                          meeting.host.workcode == $store.getters.username ||
                          meeting.convenor.workcode == $store.getters.username)
                      "
                      type="text"
                      size="medium"
                      @click="meetingstarts(meeting)"
                      >开始会议</el-button
                    >
                    <el-button
                      v-if="
                        meeting.meeting_status == 1 &&
                        (meeting.secretary.workcode ==
                          $store.getters.username ||
                          meeting.host.workcode == $store.getters.username ||
                          meeting.convenor.workcode == $store.getters.username)
                      "
                      type="text"
                      size="medium"
                      @click="meetingends()"
                      >结束会议</el-button
                    >
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
            <el-col :xl="1">
              <div style="width: 100%; height: 1px" />
            </el-col>
            <el-col
              v-if="meeting.meeting_status > 0"
              :md="24"
              :lg="24"
              :xl="12"
            >
              <div style="min-height: 100px; position: relative">
                <el-button
                  type="text"
                  style="position: absolute; right: 0; z-index: 2"
                  @click="sendMin(meeting.id)"
                  >发送决议通知</el-button
                >

                <el-tabs v-model="activeName2" @tab-click="handleClick">
                  <el-tab-pane label="我的任务" name="my" />
                  <el-tab-pane label="所有逾期" name="overdue" />
                  <el-tab-pane label="所有完成" name="complete" />
                  <el-tab-pane label="所有任务" name="all" />
                </el-tabs>
                <div style="max-height: 500px; overflow: auto">
                  <el-card
                    v-for="(item, index) in meetingtasklists"
                    :key="index"
                    shadow="never"
                    style="margin: 5px; cursor: pointer"
                  >
                    <el-row @click.native="endtask(item, item.is_complete)">
                      <el-col :span="8" style="overflow: hidden">
                        <el-popover
                          :content="item.task_name"
                          placement="left"
                          width="600"
                          trigger="hover"
                        >
                          <!-- <p slot="reference" class="taskName" @click="endtask(item,item.is_complete)">
                            {{ item.task_name }}</p> -->
                          <el-link
                            type="primary"
                            slot="reference"
                            class="taskName"
                            @click="endtask(item, item.is_complete)"
                          >
                            <p>{{ item.task_name }}</p></el-link
                          >
                          <!-- <p class="taskName">{{ item.task_name }}</p> -->
                        </el-popover>
                      </el-col>
                      <el-col :span="6" style="margin-top: 15px">
                        <el-col :span="8">
                          <el-tag
                            size="mini"
                            v-if="item.executor.length > 0"
                            type="success"
                            >{{ item.executor[0].name }}</el-tag
                          >
                        </el-col>
                        <el-col :span="15">
                          <span class="timeLine"
                            >截止时间:{{ item.planned_complete_time }}</span
                          >
                        </el-col>
                      </el-col>
                      <el-col :span="3">
                        <el-col :span="10" />
                        <el-col :span="17">
                          <!-- <span v-show="item.is_complete==0" class="undone">未完成</span> -->
                          <!-- <span v-show="item.is_complete==1" class="complete">已完成</span> -->
                          <el-tag
                            v-show="item.is_overdue === 1"
                            size="mini"
                            type="danger"
                            >已逾期</el-tag
                          >
                          <el-tag
                            v-show="item.is_complete === 0"
                            size="mini"
                            type="warning"
                            >未完成</el-tag
                          >
                          <el-tag
                            v-show="item.is_complete === 1"
                            size="mini"
                            type="success"
                            >已完成</el-tag
                          >
                          <el-tag
                            v-if="
                              item.is_complete == 0 &&
                              (meeting.secretary.workcode ==
                                $store.getters.username ||
                                meeting.host.workcode ==
                                  $store.getters.username ||
                                meeting.convenor.workcode ==
                                  $store.getters.username)
                            "
                            type="danger"
                            size="mini"
                            style="margin: 5px; cursor: pointer"
                            @click.stop="removetask(item)"
                            >删除</el-tag
                          >
                        </el-col>
                      </el-col>
                      <el-col :span="4" style="padding-top: 10px">
                        <span>{{
                          item.history.length ? item.history[0].content : ""
                        }}</span>
                      </el-col>
                      <el-col :span="3">
                        <el-button
                          v-if="item.attachments.length"
                          type="text"
                          size="mini"
                          icon="el-icon-download"
                          @click.stop="
                            downloadP(item.attachments, item.task_name)
                          "
                          >下载附件</el-button
                        >
                        <!-- <el-button v-if="item.attachments.length" type="text" size="mini" icon="el-icon-download" @click.stop="downTaskFile(item.attachments)">下载附件</el-button> -->
                        <!-- <div v-for="(file,index) in item.attachments" :key="index">
                          <a @click.stop="" style="color: #A020F0" :href="downUrl+ file.id">{{file.filename}}</a>
                        </div> -->
                      </el-col>
                    </el-row>
                  </el-card>
                </div>
                <el-button
                  v-if="
                    (meeting.meeting_status == 1 ||
                      meeting.meeting_status == 2 ||
                      meeting.meeting_status == 5) &&
                    (meeting.secretary.workcode == $store.getters.username ||
                      meeting.host.workcode == $store.getters.username ||
                      meeting.convenor.workcode == $store.getters.username)
                  "
                  type="text"
                  size="medium"
                  @click="addse"
                  >添加任务</el-button
                >
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="24" :lg="11" :xl="11">
              <el-tabs v-model="activeName1" @tab-click="handleClick1">
                <el-tab-pane label="会议纪要" name="first">
                  <el-input
                    :autosize="{ minRows: 5 }"
                    v-model="meeting.summary"
                    type="textarea"
                    placeholder="请输入内容"
                  />
                  <span
                    v-if="meeting.secretary.workcode == $store.getters.username"
                  >
                    <el-button
                      v-if="
                        meeting.meeting_status == 5 ||
                        meeting.meeting_status == 2
                      "
                      type="text"
                      size="medium"
                      @click="summary(1)"
                      >通知参会人</el-button
                    >
                  </span>
                  &nbsp;&nbsp;
                  <span
                    v-if="
                      meeting.secretary.workcode == $store.getters.username ||
                      meeting.host.workcode == $store.getters.username ||
                      meeting.convenor.workcode == $store.getters.username
                    "
                  >
                    <el-button
                      v-if="
                        meeting.meeting_status == 1 ||
                        meeting.meeting_status == 2 ||
                        meeting.meeting_status == 5
                      "
                      type="text"
                      size="medium"
                      @click="summary(0)"
                      >保存纪要
                    </el-button>
                  </span>
                </el-tab-pane>
                <el-tab-pane label="附件" name="second">
                  <!-- http://190.168.1.50:9095/api   https://api.meeting.suntekcorps.com/api/common/upload-->
                  <!-- :http-request="uploadFile" -->
                  <el-upload
                    :file-list="fileList"
                    :on-success="handleChange"
                    :headers="{ Authorization: $store.getters.token }"
                    :data="{
                      upload_type: 'attachment',
                      file_type: 'meeting',
                      relate_id: meeting.id,
                    }"
                    class="upload-demo"
                    :action="action"
                    name="files"
                  >
                    <!-- action="https://api.meeting.suntekcorps.com/api/common/upload" -->
                    <el-button
                      v-if="
                        meeting.meeting_status === 1 ||
                        meeting.meeting_status === 2 ||
                        meeting.meeting_status === 5
                      "
                      size="small"
                      type="primary"
                      >点击上传</el-button
                    >
                  </el-upload>
                  <div
                    v-for="(item, index) in meeting.attachments"
                    :key="index"
                    style="padding: 5px"
                  >
                    <a :href="item.href" :key="index" style="color: #409eff">{{
                      item.filename
                    }}</a>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="链接" name="third">
                  <div
                    v-if="
                      meeting.secretary.workcode === $store.getters.username ||
                      meeting.convenor.workcode === $store.getters.username
                    "
                  >
                    <el-form
                      :model="dynamicValidateForm"
                      ref="dynamicValidateForm"
                      class="demo-dynamic"
                      size="mini"
                    >
                      <el-form-item
                        v-for="(domain, index) in dynamicValidateForm.domains"
                        :label="'链接' + (index+1)"
                        :key="index"
                        :prop="'domains.' + index + '.value'"
                        :rules="{
                          required: true,
                          message: '链接不能为空',
                          trigger: 'blur',
                        }"
                      >
                        <el-input v-model="domain.value" style="width:70%" clearable></el-input
                        >
                         <el-button  type="text" style="color:red;font-size:14px" icon="el-icon-delete" @click.prevent="removeUrl(domain)"></el-button>

                      </el-form-item>
                      <el-form-item>

                        <el-button @click="addUrl">新增链接</el-button>
                        <el-button
                          type="primary"
                          @click="submitUrlForm('dynamicValidateForm')"
                          >更新</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                  <div v-else>
                    <p v-for="(url, uindex) in dynamicValidateForm.domains"
                        :key="uindex">{{(uindex+1)}}.<a :href="url.value" style="color:#1954bf" target="_blank">{{url.value}}</a> </p>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-col>
            <el-col :lg="1" :xl="1">
              <div style="width: 100%; height: 1px" />
            </el-col>
            <el-col :md="24" :lg="12" :xl="12">
              <el-tabs v-model="activeNamehui">
                <el-tab-pane label="会议议题" name="first">
                  <div
                    style="
                      font-size: 14px;
                      min-height: 100px;
                      border: 1px solid #ccc;
                    "
                  >
                    <p
                      v-for="(item, index) in meeting.lssue"
                      :key="index"
                      style="padding: 5px"
                    >
                      {{ index + 1 }}.
                      {{ item }}
                    </p>
                  </div>
                  <el-button
                    v-if="
                      (meeting.secretary.workcode == $store.getters.username ||
                        meeting.host.workcode == $store.getters.username ||
                        meeting.convenor.workcode == $store.getters.username) &&
                      meeting.meeting_status == 1
                    "
                    type="text"
                    size="small"
                    @click="addLssueVisible = true"
                    >添加会议议题</el-button
                  >
                </el-tab-pane>
                <el-tab-pane label="会议描述" name="second">
                  <div style="min-height: 100px; border: 1px solid #ccc">
                    <p style="padding: 5px">{{ meeting.describe }}</p>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
          <el-row>
            <!--meeting_status 0已预约 1进行中 2已结束 3未进行 4已取消 5决议处理中 6会议待评分 7 已完成 -->
            <el-col
              v-if="
                [0, 1, 2, 3, 5, 6, 7].includes(meeting.meeting_status) &&
                (meeting.secretary.workcode == $store.getters.username ||
                  meeting.host.workcode == $store.getters.username ||
                  meeting.convenor.workcode == $store.getters.username)
              "
              :md="24"
              :lg="11"
              :xl="11"
              style="min-width: 600px"
            >
              <div>
                <el-tabs v-model="activeName3">
                  <div>
                    <span style="color:red">更改参会状态，请点击 '更新' 按钮</span>
                  </div>
                  <el-tab-pane label="参会统计" name="all" />
                </el-tabs>

                <el-card style="margin-top: 5px;font-size">
                  <el-row>
                    <el-col :span="6">
                      <div>参会人</div>
                    </el-col>
                    <el-col :span="12">
                      <div>参会状态</div>
                    </el-col>
                    <el-col :span="6">
                      <div>操作</div>
                    </el-col>
                    <!-- <el-col :span="5">
                      <div>发言次数</div>
                    </el-col>
                    <el-col :span="5">
                      <div>发言时间</div>
                    </el-col> -->
                  </el-row>
                </el-card>
                <el-card
                  v-for="(item, index) in attendeeslist"
                  :key="index"
                  shadow="never"
                  style="margin-top: 5px"
                >
                  <el-row>
                    <el-col :span="6">
                      <div style="line-height: 35px">{{ item.name }}</div>
                    </el-col>
                    <el-col :span="12">
                      <div style="padding-right: 5px; line-height: 35px">
                        <el-select
                          size="mini"
                          v-model="item.u_status"
                          placeholder="请选择"
                        >
                          <el-option label="待开会" :value="0"></el-option>
                          <el-option label="参加" :value="1"></el-option>
                          <el-option label="请假" :value="2"></el-option>
                          <el-option label="早退" :value="3"></el-option>
                          <el-option label="拒绝" :value="4"></el-option>
                          <el-option label="缺席" :value="5"></el-option>
                          <el-option
                            label="会议取消不需要开会"
                            :value="6"
                          ></el-option>
                          <el-option label="会议未进行" :value="7"></el-option>
                        </el-select>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <el-button
                        type="text"
                        size="medium"
                        @click="gengxin(item, 0)"
                        >更新</el-button
                      >
                    </el-col>
                    <!-- <el-col :span="5">
                      <div style="line-height: 35px ;">
                        <el-input v-model="item.speak_num" size="mini" type="number" min="0">
                          <template slot="append">次</template>
                        </el-input>
                      </div>
                    </el-col>
                    <el-col :span="5">
                      <div style="line-height: 35px ;">
                        <el-input v-model="item.speak_time" type="number" min="0" size="mini" style="margin:0px 5px;">
                          <template slot="append">分钟</template>
                        </el-input>
                      </div>
                    </el-col>
                    <el-col v-if="item.examine!=1" :span="4">
                      <el-button style="margin-left: 35px;" type="text" size="medium" @click="gengxin(item,0)">更新
                      </el-button>
                      <el-button type="text" size="medium" @click="gengxin(item,1)">审核</el-button>
                    </el-col> -->
                  </el-row>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="任务详情" name="second">
        <taskTable :meetingtasklist="meetingtasklist" />
      </el-tab-pane>
      <el-tab-pane label="参会详情" name="third">
        <participation-table :attendees="attendees" />
      </el-tab-pane>
      <el-tab-pane label="视频回顾" name="fourth">
        <videos :srcList="meeting.attachments" />
      </el-tab-pane>
      <!-- <el-tab-pane label="我的评分" name="fifth">
        <participation-table :attendees="attendees" />
      </el-tab-pane> -->
    </el-tabs>

    <addtask
      :dialogVisible="dialogVisible"
      :list="list"
      :deliverTypeList="deliverTypeList"
      @closeAddTaskDialog="closeAddTaskDialog"
    />

    <edittask
      :dialogVisibleend="dialogVisibleend"
      :formendtask="formendtask"
      :is_complete="is_complete"
      :tasktitle="tasktitle"
      :activeName2="activeName2"
      :page="page"
      :page_size="page_size"
      :deliverTypeList="deliverTypeList"
      @closeEditTaskDialog="closeEditTaskDialog"
    />

    <el-dialog
      :visible.sync="addAttendeesVisible"
      title="添加参会者"
      width="30%"
    >
      <el-select
        v-model="dlgname13"
        :remote-method="remoteMethod13"
        :loading="loading"
        filterable
        remote
        reserve-keyword
        placeholder="请输入,支持多选"
        style="width: 80%"
        @change="changenamemix('', dlgname13, username13)"
      >
        <el-option
          v-for="(item, index) in useroptions13"
          :key="index"
          :label="item.label + '(' + item.value + ')'"
          :value="item"
        />
      </el-select>
      <el-tag
        v-for="(item, index) in username13"
        :key="index"
        closable
        clearable
        style="margin: 2px"
        @close="handleClose13(item)"
        >{{ item.name }}({{ item.username }})</el-tag
      >

      <span slot="footer" class="dialog-footer">
        <el-button @click="addAttendeesVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAttendeesBtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="addLssueVisible" title="添加会议议题" width="30%">
      <el-form label-width="80px">
        <el-form-item
          v-for="(domain, index) in lssue"
          :label="'会议议题:'"
          :key="index"
        >
          <el-input v-model="domain.value">
            <template v-if="index !== 0" slot="append">
              <i
                class="el-dialog__close el-icon el-icon-close"
                @click.prevent="removeDomain(domain)"
              />
            </template>
          </el-input>
        </el-form-item>
        <p style="text-align: center">
          <i class="el-icon-circle-plus-outline" @click="addDomain" />
        </p>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addLssueVisible = false">取 消</el-button>
        <el-button type="primary" @click="addLssueBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 已预约状态，到了开始时间段进入页面时弹窗提示。 -->
    <el-dialog :visible.sync="startTip" title="提示" width="30%">
      <div style="position: relative">
        <span style="fontsize: 24px; marginright: 12px"
          ><i class="el-icon-warning" style="color: #f2a04b"
        /></span>
        <span style="position:absolute: line-height:26px; fontSize:18px"
          >您是否要开始会议？</span
        >
      </div>
      <div slot="footer">
        <el-button size="small" type="info" @click="startTip = false"
          >否</el-button
        >
        <el-button size="small" type="primary" @click="meetingstarts(meeting)"
          >是</el-button
        >
      </div>
    </el-dialog>
    <!-- 进行中状态，三个人提示结束会议 -->
    <el-dialog :visible.sync="endTip" title="提示" width="30%">
      <div style="position: relative">
        <span style="fontsize: 24px; marginright: 12px"
          ><i class="el-icon-warning" style="color: #f2a04b"
        /></span>
        <span style="position:absolute: line-height:26px; fontSize:18px"
          >您是否要结束会议？</span
        >
      </div>
      <div slot="footer">
        <el-button size="small" type="info" @click="endTip = false"
          >否</el-button
        >
        <el-button size="small" type="primary" @click="meetingends()"
          >是</el-button
        >
      </div>
    </el-dialog>
      <endMettingDialog :propData="propData"  @close="closeDialog" />

  </div>
</template>

<script>
import tags from '@/components/tags'
import addtask from './component/addTask.vue'
import edittask from './component/editTask.vue'
import { mapGetters } from 'vuex'
import participationTable from './component/participationDetails'
import taskTable from './component/taskList'
import videos from '@/components/videoPlay/index'
import { gitusers } from '@/api/user'
import {
  meetingid,
  meetingtask,
  meetingtasks,
  taskdelete,
  attendeessearch,
  meetingstart,
  // meetingend,
  meetingsummary,
  recordSpeak,
  getHistory,
  meetingupdateOngoing,
  sendMinutesMeeting,
  searchLink,
  saveLink
} from '@/api/seedetails'
import { searchType } from '@/api/deliver'

import FileSaver from 'file-saver' // 批量打包
import JSZip from 'jszip' // 批量打包

import endMettingDialog from './component/endMettingDialog'

export default {
  components: {
    participationTable,
    taskTable,
    videos,
    tags,
    addtask,
    edittask,
    endMettingDialog
  },

  data() {
    return {
      page: 1,
      page_size: 1000,
      textarea: '',
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      addAttendeesVisible: false,
      addLssueVisible: false,
      lssue: [{ value: '' }], // 添加会议议题（会议进行中）
      checked: true,
      loading: false,
      dlgname: [],
      dlgname1: [],
      dlgname9: '', // 参与人，仿负责人
      dlgname10: '', // 参与人，仿负责人
      dlgname11: '', // zhihui人，仿负责人
      dlgname12: '', // zhihui人，仿负责人
      dlgname13: '', // zhihui人，添加参会人
      fileList: [],
      tasktitle: '更新进度',
      attendeeslist: [],
      taskfileList: [],
      filesuccess: [],
      taskfilesuccess: [],
      formendtask: {
        liability: [
          {
            name: ''
          }
        ],
        notify: [
          {
            name: ''
          }
        ],
        consultant: [
          {
            name: ''
          }
        ],
        leader: [
          {
            name: ''
          }
        ],
        complete_time: ''
      },
      frequency: '',
      Duration: '',
      dialogVisible: false,
      dialogVisibleend: false,
      value1: '',
      meetingtasklist: { data: { tasks: [] }},
      meetingtasklists: [],
      meeting: {
        applicant: {},
        host: {},
        secretary: {},
        convenor: {},
        contact: {},
        room: {},
        address: {},
        token: this.$store.getters.token
      },
      formtask: {
        meeting_id: this.$route.query.id
      },
      attendees: {},
      useroptions: [],
      useroptions1: [],
      useroptions2: [],
      useroptions3: [],
      useroptions4: [],
      useroptions5: [],
      useroptions9: [],
      useroptions10: [],
      useroptions11: [],
      useroptions12: [],
      useroptions13: [],
      users: [],
      input: '',
      list: [],
      username: [],
      username9: [],
      username10: [],
      username11: [],
      username12: [],
      username13: [],
      formLabelWidth: 200,
      activeName: 'first',
      activeName1: 'first',
      activeNamehui: 'first',
      activeName2: 'my',
      activeName3: 'all',
      taskname: 'my',
      formInline: {
        user: '',
        region: ''
      },
      rules: {
        user_id: [
          {
            required: true,
            message: '请选择负责人',
            trigger: 'change'
          }
        ],
        consultant: [
          {
            required: false,
            message: '请选择顾问',
            trigger: 'change'
          }
        ],
        notify_people_id: [
          {
            required: false,
            message: '请选择知会人',
            trigger: 'change'
          }
        ],
        planned_complete_time: [
          {
            required: true,
            message: '请选择截止日期',
            trigger: 'change'
          }
        ],

        liability_user_id: [
          {
            required: false,
            message: '请选择担责人',
            trigger: 'change'
          }
        ],
        task_name: [
          {
            required: true,
            message: '请输入会议标题',
            trigger: 'blur'
          }
        ]
      },
      rules1: {
        result_status: [
          {
            required: true,
            message: '请输入执行结果',
            trigger: 'blur'
          }
        ],
        difference: [
          {
            required: true,
            message: '请输入差异分析',
            trigger: 'blur'
          }
        ],
        complete_time: [
          {
            required: true,
            message: '请选择完成时间',
            trigger: 'change'
          }
        ],
        remark: [
          {
            required: true,
            message: '请输入备注',
            trigger: 'blur'
          }
        ]
      },
      starttime: '',
      deliverTypeList: [],
      logList: [],
      is_complete: false,
      startTip: false,
      endTip: false,
      action: process.env.VUE_APP_BASE_API + '/common/upload',
      downUrl: process.env.VUE_APP_BASE_API + '/common/download/',
      dynamicValidateForm: {
        domains: [
          // {
          //   value: ''
          // }
        ]
      },
      propData: { visible: false, form: {}}

    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  watch: {
    meetingtasklists(newName, oldName) {
      this.meetingtasklists = newName
    },
    deep: true,
    immediate: true
  },
  created() {
    const data = {
      departmentId: 0
    }
    gitusers(data)
      .then((response) => {
        this.users = response.data
        this.list = this.users.map((item) => {
          return {
            value: item.username,
            label: item.name,
            id: item.userId
          }
        })
        console.log(response)
      })
      .catch((err) => {
        console.log(err)
      })
    const data1 = {
      meeting_id: this.$route.query.id,
      task_tab: 'my',
      page: this.page,
      page_size: this.page_size
    }
    this.gettaskTable(data1)
    const attendees = {
      meeting_id: this.$route.query.id,
      page: this.page,
      page_size: 1000
    }
    this.getattendeessearch(attendees)
    this.giemeetingid()
    this.getDeliverTypeList() // 获取交付件类型列表
  },
  methods: {
    closeEditTaskDialog() {
      this.dialogVisibleend = false
    },
    closeAddTaskDialog() {
      this.dialogVisible = false
    },
    giemeetingid() {
      meetingid(this.$route.query.id)
        .then((response) => {
          for (
            let index = 0;
            index < response.data.meeting.attachments.length;
            index++
          ) {
            const element = response.data.meeting.attachments[index]

            element.href =
              process.env.VUE_APP_BASE_API + '/common/download/' + element.id
          }
          (response.data.meeting.token = this.$store.getters.token)(
            (this.meeting = response.data.meeting)
          )
          // this.dynamicValidateForm.domains = response.data.meeting.links || [] // 鏈接
          // 已预约，在预计开始时间前60分钟~~预计开始时间后30分钟，三个人
          if (
            this.meeting.secretary.workcode === this.$store.getters.username ||
            this.meeting.host.workcode === this.$store.getters.username ||
            this.meeting.convenor.workcode === this.$store.getters.username
          ) {
            if (this.meeting.meeting_status === 0) {
              const timestamp =
                this.transdate(this.meeting.estimate_start_time) * 1000
              const timeEd = timestamp - new Date().getTime()
              if (timeEd < 3600000 && timeEd > -1800000) {
                this.startTip = true
              } else {
                this.startTip = false
              }
            }
            if (this.meeting.meeting_status === 1) {
              // 如果当前时间大于实际开始时间10分钟，弹窗提示结束，否则开定时器10分钟后弹窗
              const timestamp = this.transdate(this.meeting.start_time) * 1000
              const timeEd = new Date().getTime() - timestamp
              if (timeEd > 600000) {
                this.endTip = true
              } else {
                const clear = () => {
                  clearTimeout(timer)
                }
                clear()
                const timer = setTimeout(() => {
                  this.endTip = true
                }, 600000)
              }
            }
          } else {
            // this.startTip = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    gengxin(item, type) {
      console.log(item)
      const data = {
        meeting_id: this.$route.query.id,
        workcode: item.workcode,
        speak_num: item.speak_num,
        speak_time: item.speak_time,
        u_status: item.u_status,
        examine: type
      }
      recordSpeak(data)
        .then((response) => {
          console.log(response)
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success'
          })
          // const attendees = {
          //   meeting_id: this.$route.query.id,
          //   page: this.page,
          //   page_size: 100
          // }
          // this.getattendeessearch(attendees)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getattendeessearch(attendees) {
      attendeessearch(attendees)
        .then((response) => {
          console.log(response)
          this.attendees = response
          this.attendeeslist = response.data.attendees
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleChange(responses, file, fileList) {
      this.fileList = []
      this.giemeetingid()
    },
    // 日期转时间戳
    transdate(endTime) {
      var date = new Date()
      date.setFullYear(endTime.substring(0, 4))
      date.setMonth(endTime.substring(5, 7) - 1)
      date.setDate(endTime.substring(8, 10))
      date.setHours(endTime.substring(11, 13))
      date.setMinutes(endTime.substring(14, 16))
      date.setSeconds(endTime.substring(17, 19))
      return Date.parse(date) / 1000
    },
    taskhandleChange(responses, file, fileList) {
      this.taskfileList = []
      responses.data.attachment[0].href =
        process.env.VUE_APP_BASE_API +
        '/common/download/' +
        responses.data.attachment[0].id
      this.formendtask.attachments.push(responses.data.attachment[0])
    },
    meetingstarts(item) {
      this.$confirm('确认开始会议, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.startTip = false
          meetingstart({
            meeting_id: this.$route.query.id,
            is_night: 0
          })
            .then((response) => {
              if (response.code === 'success') {
                this.$message({
                  type: 'success',
                  message: '成功!'
                })
                this.$store.dispatch('getMeetingRun')
                meetingid(this.$route.query.id)
                  .then((response) => {
                    console.log(response)
                    response.data.meeting.token = this.$store.getters.token
                    this.meeting = response.data.meeting
                  })
                  .catch((err) => {
                    console.log(err)
                  })
                const attendees = {
                  meeting_id: this.$route.query.id,
                  page: this.page,
                  page_size: 100
                }
                this.getattendeessearch(attendees)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    meetingends() {
      this.propData = {
        form: { ...this.meeting, is_held: 1 },
        visible: true
      }
      // this.endTip = false
      // this.$confirm(
      //   '确认结束会议，请在"参会统计”中确认人员参会状态，如已确认请继续！',
      //   '提示',
      //   {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }
      // )
      //   .then(() => {
      //     meetingend({
      //       meeting_id: this.$route.query.id,
      //       is_night: 0,
      //       is_held: 1
      //     })
      //       .then((response) => {
      //         this.$message({
      //           type: 'success',
      //           message: '成功!'
      //         })
      //         console.log(response)
      //         this.$store.dispatch('getMeetingRun')
      //         meetingid(this.$route.query.id)
      //           .then((response) => {
      //             console.log(response)
      //             response.data.meeting.token = this.$store.getters.token
      //             this.meeting = response.data.meeting
      //           })
      //           .catch((err) => {
      //             console.log(err)
      //           })
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       })
      //   })
      //   .catch(() => {})
    },
    closeDialog(type) {
      this.propData.visible = false
      if (type) { // 编辑成功调用查询
        const attendees = {
          meeting_id: this.$route.query.id,
          page: this.page,
          page_size: 1000
        }
        this.getattendeessearch(attendees)
        this.giemeetingid()
      }
    },
    summary(type) {
      const THIs = this

      if (this.meeting.summary === '') {
        THIs.$message({
          type: 'error',
          message: '请填写会议内容!'
        })
        return
      }

      if (type === 1) {
        this.$confirm('确认通知参会人, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            meetingsummary({
              meeting_id: THIs.$route.query.id,
              summary: THIs.meeting.summary,
              is_notice: type
            })
              .then((response) => {
                console.log(response)
                THIs.$message({
                  type: 'success',
                  message: '通知成功!'
                })
              })
              .catch((err) => {
                console.log(err)
              })
          })
          .catch(() => {
            THIs.$message({
              type: 'info',
              message: '已取消'
            })
          })
      } else {
        meetingsummary({
          meeting_id: THIs.$route.query.id,
          summary: THIs.meeting.summary,
          is_notice: type
        })
          .then((response) => {
            console.log(response)
            THIs.$message({
              type: 'success',
              message: '保存成功!'
            })
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    handleClick(tab, event) {
      // 所有任务列表秘书 主持人可以操作进度 三个人
      if (
        tab.name === 'all' &&
        ![
          this.meeting.secretary.workcode,
          this.meeting.host.workcode,
          this.meeting.convenor.workcode
        ].includes(this.$store.getters.username)
      ) {
        this.tasktitle = '编辑任务'
      } else {
        this.tasktitle = '更新进度'
      }

      this.taskname = tab.name
      console.log(tab, event)
      const data1 = {
        meeting_id: this.$route.query.id,
        task_tab: tab.name,
        page: this.page,
        page_size: this.page_size
      }
      this.gettaskTable(data1)
    },
    handleClickTab(tab, event) {
      // zeng加,獲取任务吴数据
      if (tab.name === 'second') {
        const data = {
          meeting_id: this.$route.query.id,
          task_tab: 'all'
        }
        meetingtasks(data)
          .then((response) => {
            this.meetingtasklist = response
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    gettaskTable(data1) {
      meetingtasks(data1)
        .then((response) => {
          if (data1.task_tab === 'all') {
            this.meetingtasklist = response
          }
          this.meetingtasklists = response.data.tasks || []
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    endtask(item, is_complete) {
      if (is_complete === 1) {
        // 已完成不能编辑
        this.$message({
          message: '已完成 的任务不能编辑',
          type: 'warning'
        })
        this.is_complete = true // 字段限制  确定按钮的显示
      } else {
        this.is_complete = false
      }
      for (let index = 0; index < item.attachments.length; index++) {
        const element = item.attachments[index]
        element.href =
          `${process.env.VUE_APP_BASE_API}/common/download/` + element.id
        // element.href = ' http://190.168.1.50:9095/api/common/download/' + element.id
      }

      this.formendtask = {
        task_name: item.task_name,
        liability: item.liability.length > 0 ? item.liability[0] : [],
        liabilityname: item.liability.length > 0 ? item.liability[0].name : '',
        consultant: item.consultant.length > 0 ? item.consultant[0] : [],
        consultantname:
          item.consultant.length > 0 ? item.consultant[0].name : '',
        notify: item.notify.length > 0 ? item.notify[0] : [],
        notifyname: item.notify.length > 0 ? item.notify[0].name : '',
        // leader: item.leader[0],
        // leadername: item.leader[0].name,
        executor: item.executor,
        planned_complete_time: item.planned_complete_time,
        complete_time:
          item.complete_time === '0000-00-00 00:00:00'
            ? ''
            : item.complete_time, // 解决显示1989

        is_complete: item.is_complete.toString(),
        result_status: item.result_status,
        difference: item.difference,
        remark: item.remark,
        attachments: item.attachments || [],
        id: item.id,
        create_user_id: item.creator_workcode,
        userid: this.$store.getters.username,
        deliver_type_id: item.deliver_type_id,
        task_desc: item.task_desc,
        deliver_content: item.deliver_content
      }

      // 点击编辑
      this.username10 = []
      for (const i in item.participant) {
        const obj = {
          username: item.participant[i].workcode,
          name: item.participant[i].name
        }
        this.username10.push(obj)
      }

      // 编辑带出只会人
      this.username12 = []
      for (const i in item.notify) {
        const obj = {
          username: item.notify[i].workcode,
          name: item.notify[i].name
        }
        this.username12.push(obj)
      }
      // 获取每个任务的进度列表
      getHistory(item.id)
        .then((res) => {
          if (res.data.history) {
            this.logList = res.data.history
            // this.formendtask.remark = res.data.history[0].content
            this.formendtask.remark = ''
            this.formendtask.history = JSON.parse(
              JSON.stringify(res.data.history)
            )
          } else {
            this.logList = []
            this.formendtask.history = []
          }
          this.dialogVisibleend = true
        })
        .catch((err) => {
          console.log(err)
        })
    },

    removetask(item) {
      getHistory(item.id)
        .then((res) => {
          if (res.data.history.length > 0) {
            this.$message.error('这条任务有进度不能删除！')
          } else {
            this.$confirm('此操作将删除该任务, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                taskdelete(item.id)
                  .then((response) => {
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    })
                    const data1 = {
                      meeting_id: this.$route.query.id,
                      task_tab: 'all',
                      page: this.page,
                      page_size: this.page_size
                    }
                    this.gettaskTable(data1)
                  })
                  .catch((err) => {
                    console.log(err)
                  })
              })
              .catch(() => {})
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addtask(formName) {
      if (this.formtask.deliver_type_id) {
        console.log('')
      } else {
        this.$message({
          message: '请填写交付件类型',
          type: 'warning'
        })
        return false
      }

      if (this.username.length > 0) {
        const THIs = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const task_name = THIs.formtask.task_name
            const meeting_id = THIs.$route.query.id

            let liability = ''
            if (THIs.formtask.liability_user_id) {
              liability = {
                user_id: THIs.formtask.liability_user_id.id,
                name: THIs.formtask.liability_user_id.label,
                workcode: THIs.formtask.liability_user_id.value
              }
            }

            let consultant = ''
            if (THIs.formtask.consultant) {
              consultant = {
                user_id: THIs.formtask.consultant.id,
                name: THIs.formtask.consultant.label,
                workcode: THIs.formtask.consultant.value
              }
            }
            // let notify = ''
            if (THIs.formtask.notify_people_id) {
              // notify = {
              //   user_id: THIs.formtask.notify_people_id.id,
              //   name: THIs.formtask.notify_people_id.label,
              //   workcode: THIs.formtask.notify_people_id.value
              // }
            }

            // const leader = {
            //   user_id: THIs.formtask.user_id.id,
            //   name: THIs.formtask.user_id.label,
            //   workcode: THIs.formtask.user_id.value
            // }
            const executor = []
            console.log(this.username)

            for (let index = 0; index < this.username.length; index++) {
              const element = this.username[index]
              const data = {
                user_id: element.id,
                name: element.name,
                workcode: element.username
              }
              executor.push(data)
            }
            // 参会人处理
            const participant = []
            for (let index = 0; index < this.username9.length; index++) {
              const element = this.username9[index]
              const data9 = {
                user_id: element.id,
                name: element.name,
                workcode: element.username
              }
              participant.push(data9)
            }

            const notify = []
            for (let index = 0; index < this.username11.length; index++) {
              const element = this.username11[index]
              const data11 = {
                user_id: element.id,
                name: element.name,
                workcode: element.username
              }
              notify.push(data11)
            }

            const planned_complete_time = THIs.formtask.planned_complete_time
            const data = {
              task_name: task_name,
              meeting_id: meeting_id,
              liability: liability,
              consultant: consultant,
              notify: notify,
              // leader: leader,
              executor: executor,
              planned_complete_time: planned_complete_time,
              deliver_type_id: THIs.formtask.deliver_type_id,
              task_desc: THIs.formtask.task_desc,
              participant: participant // 参会人
            }
            meetingtask(data)
              .then((response) => {
                console.log(response)
                this.dialogVisible = false
                this.$message({
                  message: '任务创建成功',
                  type: 'success'
                })
                THIs.formtask = {}
                THIs.dlgname = []
                THIs.dlgname9 = []
                THIs.dlgname10 = []
                THIs.dlgname11 = []
                THIs.dlgname12 = []
                THIs.username = []
                THIs.useroptions5 = []
                THIs.useroptions4 = []
                THIs.useroptions3 = []
                THIs.useroptions2 = []
                THIs.useroptions1 = []

                this.activeName2 = 'my'
                const data1 = {
                  meeting_id: this.$route.query.id,
                  task_tab: 'my',
                  page: this.page,
                  page_size: this.page_size
                }

                this.gettaskTable(data1)
              })
              .catch((err) => {
                console.log(err)
              })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      } else {
        this.$message({
          message: '请选择负责人',
          type: 'warning'
        })
      }
    },

    changenamemix(val, whichData, username) {
      const list = {}
      list.name = whichData.label
      list.username = whichData.value
      list.id = whichData.id

      let is = true
      if (username.length > 0) {
        for (let index = 0; index < username.length; index++) {
          const element = username[index]
          if (list.username === element.username) {
            is = false
          }
        }
      } else {
        is = true
      }
      if (is) {
        username.push(list)
      }
    },
    addse() {
      this.dialogVisible = true
    },
    handleClose13(tag) {
      this.username13.splice(this.username13.indexOf(tag), 1)
    },
    remoteMethod13(query) {
      // 参会人
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions13 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.useroptions13 = []
      }
    },

    // 获取交付件类型
    getDeliverTypeList() {
      const form = { page_size: 1000, page: 1 }
      searchType(form)
        .then((response3) => {
          if (response3.code === 'success') {
            if (response3.data.types) {
              this.deliverTypeList = response3.data.types
            } else {
              this.deliverTypeList = []
            }
          } else {
            this.errMsg()
          }
        })
        .catch()
    },
    // 添加参会者
    addAttendeesBtn() {
      const attendees = []
      for (let index = 0; index < this.username13.length; index++) {
        const element = this.username13[index]
        const data13 = {
          name: element.name,
          workcode: element.username
        }
        attendees.push(data13)
      }
      const obj = {
        action: 'addAttendees ',
        attendees: attendees
      }
      meetingupdateOngoing(this.$route.query.id, obj).then((res) => {
        if (res.code === 'success') {
          this.$message({
            message: '添加成功！',
            type: 'success'
          })
          this.addAttendeesVisible = false
          this.username13 = []

          this.activeName2 = 'my'
          const data1 = {
            meeting_id: this.$route.query.id,
            task_tab: 'my',
            page: this.page,
            page_size: this.page_size
          }
          this.gettaskTable(data1)
        }
      })
    },
    // 删除议题
    removeDomain(item) {
      var index = this.lssue.indexOf(item)
      if (index !== -1) {
        this.lssue.splice(index, 1)
      }
    },
    // 添加议题
    addDomain() {
      this.lssue.push({
        value: '',
        key: Date.now()
      })
    },
    // 提交议题修改 只有会议开始中有
    addLssueBtn() {
      const params = []
      for (let index = 0; index < this.lssue.length; index++) {
        params.push(this.lssue[index].value)
      }
      const obj = {
        action: 'updateLssue  ',
        lssue: params
      }

      meetingupdateOngoing(this.$route.query.id, obj).then((res) => {
        if (res.code === 'success') {
          this.addLssueVisible = false

          this.$message({
            message: '添加成功！',
            type: 'success'
          })
          this.lssue = [{ value: '' }]

          this.$router.go(0) // 刷新
        }
      })
    },
    uploadFile(files) {
      // 覆盖组件上传方法，自定义
      // 分片上传
      const _this = this
      var file = files.file
      // var time = new Date().getTime()
      var upload = function(file, num) {
        var formData = new FormData()
        var blockSize = 1024 * 1000
        var blockNum = Math.ceil(file.size / blockSize)
        var nextSize = Math.min(num * blockSize, file.size)
        var fileData = file.slice((num - 1) * blockSize, nextSize)
        formData.append('upload_type', 'attachment')
        formData.append('file_type', 'meeting')
        formData.append('relate_id', _this.meeting.id)
        formData.append('files', fileData)
        formData.append('filename', file.name)
        console.log(file, 'file')

        // 创建异步对象
        var xhr = new XMLHttpRequest()
        // 设置请求的类型及url
        // post请求一定要添加请求头才行不然会报错
        xhr.open('post', _this.action)
        xhr.setRequestHeader('Authorization', _this.$store.getters.token)
        // 发送请求
        xhr.send(formData)
        xhr.onreadystatechange = function() {
          // 这步为判断服务器是否正确响应
          if (xhr.readyState === 4 && xhr.status === 200) {
            console.log(xhr.responseText)
            const txt = (num * 100) / blockNum + '%'
            console.log(txt)
          }
        }
      }
      upload(file, 1)
    },
    sendMin(id) {
      this.$confirm('此操作将发送钉钉和邮件通知, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          sendMinutesMeeting(id)
            .then((res) => {
              if (res.code === 'success') {
                this.$message({
                  type: 'success',
                  message: '发送成功!'
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '发送失败!'
                })
              }
            })
            .catch((err) => {
              this.$message({
                type: 'error',
                message: '发送失败!'
              })
              console.log(err)
            })
        })
        .catch(() => {})
    },
    // downTaskFile(files) {
    //   console.log(files)
    //   downloadF(files[0].id).then(res => {

    //   })
    //   files.forEach(element => {
    //     window.open([this.downUrl + element.id], ['_blank'])

    //     setTimeout(() => {

    //     }, 2000)
    //   })
    // },
    downloadP(attachments, name) {
      const arr = []
      attachments.forEach((element) => {
        arr.push({
          name: element.filename,
          url: this.downUrl + element.id
        })
      })

      const download = (files, filename) => {
        const zip = new JSZip()
        const folder = zip.folder('files')
        Promise.resolve()
          .then(() => {
            return files.reduce((accumulator, file) => {
              return accumulator.then(() =>
                fetch(file.url)
                  .then((resp) => resp.blob())
                  .then((blob) => folder.file(file.name, blob))
              )
            }, Promise.resolve())
          })
          .then(() => {
            folder
              .generateAsync({ type: 'blob' })
              .then((content) => FileSaver.saveAs(content, filename))
          })
      }
      download(arr, '任务-【' + name + '】附件.zip')
    },
    submitUrlForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const links = this.dynamicValidateForm.domains.map(ele => ele.value)
          saveLink({ meeting_id: this.meeting.id, links: links }).then(res => {
            if (res.code === 'success') {
              this.$message.success('更新成功')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    removeUrl(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    addUrl() {
      this.dynamicValidateForm.domains.push({
        value: '',
        key: Date.now()
      })
    },
    handleClick1(tab) {
      if (tab.name === 'third') {
        searchLink({ meeting_id: this.meeting.id }).then(res => {
          const links = res.data.links
          const url = []
          if (links.length) {
            links.forEach(ele => {
              url.push({
                value: ele
              })
            })
          }
          this.dynamicValidateForm.domains = url || []
        })
      }
    }

  }
}
</script>

<style style lang="scss">
.infoBox {
  .el-card__body {
    padding: 2px 10px;
  }
}
</style>
<style style lang="scss" scoped>
.infoBox {
  padding: 0px 20px;
  background-color: #fff;

  .heade {
    // float: left;
    position: relative;
    // margin-left: 80px;
    left: 115px;
    top: 11px;
  }

  .box-card {
    font-size: 14px;
    color: rgb(94, 90, 90);
  }

  .tabsBox {
    // background-color: #f4f5f4;
  }

  .title {
    font-size: 20px;
    color: #000;
  }

  .toolBox {
    text-align: end;
  }

  .footer {
    border-top: 1px solid #ebeef5;
  }
}

.fdg {
  width: 48%;
  display: inline-block;
}

.taskBox {
  width: 50%;

  .person {
    display: inline-block;
    width: 45px;
    height: 45px;
    background-color: #f5b153;
    text-align: center;
    line-height: 45px;
    border-radius: 50%;
    color: #fff;

    &:nth-child(even) {
      background-color: #ff8170;
    }

    &:nth-child(odd) {
      background-color: #f5b153;
    }
  }
}

.timeLine {
  font-size: 12px;
  color: #333;
  margin-top: 10px;
}

.undone {
  font-size: 12px;
  color: red;
}

.complete {
  font-size: 12px;
  color: #409eff;
}

.taskName {
  // margin: 0 5px;
  // word-wrap: break-word;
  // word-break: break-all;
  // overflow: hidden;
  // 多行显示省略号，数字3为超出3行显示，

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.grid-content {
  text-align: center;
}

.el-tab-pane {
  font-size: 14px;
}

.talkCard {
  margin-top: 5px;
  width: 50%;
  font-size: 14px;
}

.el-icon-circle-plus-outline {
  font-size: 30px;
  color: rgb(223, 218, 213);
  cursor: pointer;
}

.them {
  font-weight: 700;
  font-size: 14px;
}
</style>
